// CabinetChildrenList.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import CabinetChildrenCard from './CabinetChildrenCard';
import { childrenApi } from './api/childrenApi';
import './CabinetChildrenList.css';

const CabinetChildrenList = ({ apiClient }) => {
  const [childrenData, setChildrenData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadChildrenData();
  }, []);

  const loadChildrenData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Загрузка списка детей пользователя
      const userChildren = await childrenApi.getUserChildren(apiClient);
      
      if (!userChildren || userChildren.length === 0) {
        setChildrenData([]);
        return;
      }

      // Для каждого ребенка загружаем дополнительную информацию
      const childrenWithDetails = await Promise.all(
        userChildren.map(async (ch_info) => {

          try {
            const { child, kg } = ch_info;
            // Получаем ID садиков из статусов ребенка
            const kgIds = child.statuses
              .filter(st => st && st.kindergartenId)
              .map(st => st.kindergartenId);

            if (kgIds.length === 0) {
              return { child, kg: [], isInKindergarten: kg.length > 0 };
            }

            // Загружаем информацию о садиках
            const kgInfo = await childrenApi.getKindergartenShortInfo(kgIds, apiClient);
            
            // Сопоставляем садики со статусами
            const matchedKg = kgInfo.map(kg => {
              const childStatus = child.statuses.find(st => st.kindergartenId === kg._id);
              return {
                ...kg,
                currentStatus: childStatus
              };
            });

            return { child, kg: matchedKg, isInKindergarten: kg.length > 0 };
          } catch (childError) {
            console.error(`Error loading data for child ${ch_info.child?.firstName}:`, childError);
            return { child: ch_info.child, kg: [], error: childError.message };
          }
        })
      );

      setChildrenData(childrenWithDetails);
    } catch (err) {
      console.error('Error loading children data:', err);
      setError('Не вдалося завантажити дані дітей. Спробуйте пізніше.');
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    loadChildrenData();
  };

  if (loading) {
    return (
      <div className="cabinet-children-list">
        <Container fluid>
          <Row>
            <Col md={12} className="text-center">
              <div className="loading-spinner">
                <Spinner animation="border" role="status" variant="primary" />
                <div className="loading-text">Завантаження даних дітей...</div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cabinet-children-list">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Alert variant="danger" className="error-alert">
                <Alert.Heading>Помилка завантаження</Alert.Heading>
                <p>{error}</p>
                <div className="alert-actions">
                  <button className="btn btn-primary" onClick={handleRetry}>
                    Спробувати знову
                  </button>
                </div>
              </Alert>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (childrenData.length === 0) {
    return (
      <div className="cabinet-children-list">
        <Container fluid>
          <Row>
            <Col md={12}>
              <div className="no-children-message">
                <h3>Інформація про ваших дітей в садочках відсутня </h3>
                <p>У вашому обліковому записі поки що немає інформації про дітей в садочку.</p>
                {false && <button className="btn btn-primary">Додати дитину</button>}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className="cabinet-children-list">
      <Container fluid>
        <Row>
          <Col md={12}>
           
            
            <div className="children-cards-container">
              {childrenData.map((childData, index) => (
                <CabinetChildrenCard
                  key={childData.child._id || index}
                  data={childData}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CabinetChildrenList;